import {Drawer} from 'presentation/components/Drawer';
import {translations} from 'presentation/translations-new';
import React, {Fragment, Suspense, lazy} from 'react';
import {ShortCutWarningDrawerProps} from './types';

const {emergencyTelehealth} = translations['pt-br'].privateFlow.services;

const componentMap: Record<
	string,
	() => Promise<{default: React.ComponentType<{onClose: VoidFunction; title: string}>}>
> = {
	[emergencyTelehealth]: () =>
		import('./Components/UrgencyConsultationAlertContent').then(module => ({
			default: module.UrgencyConsultationAlertContent,
		})),
};

function ShortcutWarningDrawer({title, onClose, open}: ShortCutWarningDrawerProps) {
	const DrawerContent = title && componentMap[title] ? lazy(componentMap[title]) : null;

	return (
		<Fragment>
			<Drawer.Root
				open={open}
				onClose={onClose}
				onOpen={() => {}}
				width="600px"
				customMaxHeight="100%">
				<Suspense fallback={<></>}>
					{DrawerContent ? <DrawerContent onClose={onClose} title={title} /> : null}
				</Suspense>
			</Drawer.Root>
		</Fragment>
	);
}

export {ShortcutWarningDrawer};
